import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import ProfileDropdown from './ProfileDropdown';
import MobileNavigation from './MobileNavigation';
import { fetchProfilePhoto } from '../../auth/graphService';
import { logoConfig } from '../../assets/logos';


const Header: React.FC = () => {
  const { accounts } = useMsal();
  const [avatar, setAvatar] = useState<string | undefined>(undefined);

  // Get user info from MSAL
  const user = accounts[0] ? {
    name: accounts[0].name || accounts[0].username || 'User',
    avatar
  } : { name: 'User', avatar: undefined };

  // Fetch M365 profile photo on mount or account change
  useEffect(() => {
    let isMounted = true;
    if (accounts[0]) {
      fetchProfilePhoto().then(photo => {
        if (isMounted) setAvatar(photo);
      });
    } else {
      setAvatar(undefined);
    }
    return () => { isMounted = false; };
  }, [accounts]);

  return (
    <header className="bg-gray-800 shadow-sm border-b border-gray-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-6">
            {/* Logo for mobile/tablet */}
            <div className="flex items-center space-x-3">
              <img 
                src={logoConfig.dark} 
                alt={logoConfig.alt}
                className="h-8 w-auto"
              />
            </div>
          </div>
          
          {/* User Profile Section */}
          <div className="flex items-center space-x-4">
            <MobileNavigation />
            <ProfileDropdown 
              userName={user.name}
              userAvatar={user.avatar}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
